import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { List, X, CaretDown } from "@phosphor-icons/react";

const NAV = [
  { label: "Home", to: "/" },
  {
    label: "About", to: "/about",
    children: [
      { label: "Biography & Philosophy", to: "/about" },
      { label: "Awards & Recognition", to: "/awards" },
      { label: "Professional Timeline", to: "/about#timeline" },
    ],
  },
  { label: "Clinical Expertise", to: "/clinical-expertise" },
  { label: "Research", to: "/research" },
  { label: "Impact", to: "/impact" },
  { label: "Education", to: "/education" },
  { label: "Media", to: "/media" },
  { label: "Insights", to: "/insights" },
  { label: "Gallery", to: "/gallery" },
  { label: "Contact", to: "/contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => { setOpen(false); }, [loc.pathname]);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 z-50 w-full border-b transition-[background-color,border-color] duration-300 ${
        scrolled ? "glass border-slate-200" : "bg-transparent border-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-10">
        <Link to="/" data-testid="logo-link" className="flex flex-col leading-none">
          <span className={`font-serif text-xl tracking-tight transition-colors duration-300 ${scrolled ? "text-navy" : "text-white"}`}>Dr. Bhawna Sirohi</span>
          <span className="overline mt-1 text-[9px] text-gold">Medical Director · Senior Medical Oncologist</span>
        </Link>

        <nav className="hidden items-center gap-1 xl:flex">
          {NAV.map((item) => (
            <div key={item.label} className="group relative">
              <Link
                to={item.to}
                data-testid={`nav-${item.label.toLowerCase().replace(/\s/g, "-")}`}
                className={`flex items-center gap-1 rounded-md px-3 py-2 text-[13px] font-medium transition-colors duration-200 hover:text-gold ${scrolled ? "text-navy/80" : "text-white/90"}`}
              >
                {item.label}
                {item.children && <CaretDown size={11} weight="bold" />}
              </Link>
              {item.children && (
                <div className="invisible absolute left-0 top-full w-60 translate-y-1 rounded-md border border-slate-200 bg-white p-2 opacity-0 shadow-lg transition-[opacity,transform] duration-200 group-hover:visible group-hover:translate-y-0 group-hover:opacity-100">
                  {item.children.map((c) => (
                    <Link key={c.label} to={c.to} className="block rounded px-3 py-2 text-[13px] text-navy/75 hover:bg-softgrey hover:text-navy">
                      {c.label}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}
          <Link to="/consultation" data-testid="nav-consultation-cta" className="ml-3 rounded-md bg-navy px-4 py-2 text-[13px] font-semibold text-white transition-[background-color] duration-200 hover:bg-navy-700">
            Request Consultation
          </Link>
        </nav>

        <button className={`xl:hidden ${scrolled ? "text-navy" : "text-white"}`} data-testid="mobile-menu-toggle" onClick={() => setOpen(!open)}>
          {open ? <X size={26} /> : <List size={26} />}
        </button>
      </div>

      {open && (
        <div className="xl:hidden glass border-t border-slate-200 max-h-[80vh] overflow-y-auto">
          <div className="flex flex-col px-6 py-4">
            {NAV.map((item) => (
              <Link key={item.label} to={item.to} className="border-b border-slate-100 py-3 text-sm font-medium text-navy/85">
                {item.label}
              </Link>
            ))}
            <Link to="/consultation" className="mt-4 rounded-md bg-navy px-4 py-3 text-center text-sm font-semibold text-white">
              Request Consultation
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
